import { booleanAttribute } from "#ce/utils/props";
import { eventReviewProps } from "#ce/components/SpCheckout/props/event-review";

export const typeOptions = ["checkout", "waitlist"];

export const props = Object.freeze({
  /**
   * Which element backs the registration: `checkout` renders `sp-checkout`, `waitlist` renders
   * `sp-waitlist`.
   *
   * @type {String}
   * @values checkout, waitlist
   */
  type: {
    type: String,
    required: true,
    validator: (value) => typeOptions.includes(value),
  },
  /**
   * Identifier of the event, set by the Rails `event_registration_tag` helper.
   *
   * @type {String}
   * @default undefined
   */
  // TODO: nothing reads this — https://github.com/combinaut/sparkle/issues/29145
  eventId: {
    type: String,
    default: undefined,
  },
  /**
   * Endpoint the event is fetched from, lazily on first open. Also the origin client errors are
   * reported against.
   *
   * @type {String}
   * @default undefined
   */
  url: {
    type: String,
    default: undefined,
  },
  /**
   * Open the modal on mount.
   *
   * @type {Boolean|String}
   * @default false
   */
  open: booleanAttribute(),
  /**
   * Label of the activator that opens the registration.
   *
   * @type {String}
   * @default undefined
   */
  activatorText: {
    type: String,
    default: undefined,
  },
  /**
   * Label of the sticky call-to-action shown on small screens alongside the inline activator.
   *
   * @type {String}
   * @default undefined
   */
  mobileCtaActivatorText: {
    type: String,
    default: undefined,
  },
  /**
   * Stylesheet applied to the slotted form builder markup inside the shadow root. Supplied by the
   * `SpEventRegistration` defaults in `/sp_components/configuration.json`; consecutive capitals do
   * not survive Vue's attribute hyphenation, so it has no attribute form.
   *
   * @type {String}
   * @default undefined
   */
  supportCSSUrl: {
    type: String,
    default: undefined,
  },
  /**
   * Message shown when the event fetch fails. Defaults to a built-in string.
   *
   * @type {String}
   * @default undefined
   */
  errorMessage: {
    type: String,
    default: undefined,
  },
  /**
   * Label of the button that retries a failed fetch. Defaults to "Try again".
   *
   * @type {String}
   * @default undefined
   */
  retryActivatorText: {
    type: String,
    default: undefined,
  },
  ...eventReviewProps,
});
